module.exports = __webpack_public_path__ + "static/media/pic2.ad19e113.jpg";